var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
//import { ClickAwayListener } from '@mui/material';
import { ClickAwayListener } from '@material-ui/core';
import moment from 'moment';
import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { formatString, _T } from '../../../include/appI18n';
import appSettings from '../../../include/appSettings';
import { BootstrapDatetimePicker } from '../../../include/react-components/BootstrapDatePicker';
import { BootstrapSelectPicker } from '../../../include/react-components/BootstrapSelectPicker';
import { TouristDocumentType } from '../types';
import { useCartOrder } from './CartOrder';
import { parseAutofillDate, useAutofillSync } from './useAutofillSync';
const foreignPassportId = { name: _T.COMMON_DOC_TYPE_FOREIGN_PASSWORD, value: TouristDocumentType.RussianForeignPassport, };
const russianId = { name: _T.COMMON_DOC_TYPE_PASSWORD_RF, value: TouristDocumentType.RussianPassport, };
const birthCert = { name: _T.COMMON_DOC_TYPE_BIRTH_CERT, value: TouristDocumentType.RussianBirthCertificate, };
const foreignDocumentId = { name: _T.COMMON_DOC_TYPE_FOREIGN_DOCUMENT, value: TouristDocumentType.ForeignDocument, };
const defaultTouristFieldOrder = ['gender', 'surname', 'name', 'middleName', 'birthDate', 'citizenship', 'docType', 'docNumber', 'docExpirationDate', 'docDate'];
const defaultTouristFieldLayouts = {
    gender: { name: 'gender', order: 0, section: 'person', className: 'col-xs-12' },
    surname: { name: 'surname', order: 10, section: 'fields', className: 'col-md-3 col-xs-12' },
    name: { name: 'name', order: 20, section: 'fields', className: 'col-md-3 col-xs-12' },
    middleName: { name: 'middleName', order: 30, section: 'fields', className: 'col-md-3 col-xs-12' },
    birthDate: { name: 'birthDate', order: 40, section: 'fields', className: 'col-md-3 col-xs-12' },
    citizenship: { name: 'citizenship', order: 50, section: 'fields', className: 'col-md-3 col-xs-12' },
    docType: { name: 'docType', order: 60, section: 'fields', className: 'col-md-3 col-xs-12' },
    docNumber: { name: 'docNumber', order: 70, section: 'fields', className: 'col-md-3 col-xs-12' },
    docExpirationDate: { name: 'docExpirationDate', order: 80, section: 'fields', className: 'col-md-3 col-xs-12' },
    docDate: { name: 'docDate', order: 90, section: 'fields', className: 'col-md-3 col-xs-12' },
};
const touristFieldNameAliases = {
    gender: 'gender',
    sex: 'gender',
    surname: 'surname',
    lastname: 'surname',
    familyname: 'surname',
    name: 'name',
    firstname: 'name',
    middlename: 'middleName',
    patronymic: 'middleName',
    birthdate: 'birthDate',
    birthday: 'birthDate',
    citizenship: 'citizenship',
    citizencountryid: 'citizenship',
    citizen: 'citizenship',
    doctype: 'docType',
    documenttype: 'docType',
    docnumber: 'docNumber',
    documentnumber: 'docNumber',
    docdate: 'docDate',
    documentdate: 'docDate',
    documentissuedate: 'docDate',
    docexpirationdate: 'docExpirationDate',
    documentexpirationdate: 'docExpirationDate',
    documentexpiredate: 'docExpirationDate',
};
const commonNameRegex = /^[A-Za-zА-Яа-яЁё \-]+$/;
const foreignPassportNameRegex = /^[A-Za-z \-]+$/;
function normalizeTouristFieldName(name) {
    if (!name)
        return undefined;
    return touristFieldNameAliases[name.replace(/[-_\s]/g, '').toLowerCase()];
}
function buildLayoutClassName(layout, fallbackClassName) {
    if (layout.className !== undefined)
        return layout.className;
    const classes = [];
    if (layout.colMd !== undefined)
        classes.push(`col-md-${layout.colMd}`);
    if (layout.colSm !== undefined)
        classes.push(`col-sm-${layout.colSm}`);
    if (layout.colXs !== undefined)
        classes.push(`col-xs-${layout.colXs}`);
    return classes.length ? classes.join(' ') : fallbackClassName;
}
export const BlurAcceptInput = forwardRef((_a, originalRef) => {
    var { mask } = _a, props = __rest(_a, ["mask"]);
    const [value, setValue] = useState(props.value || undefined);
    const inputRef = useRef(originalRef);
    //const inputRef = useMemo(() => ({ current: (ref as any)?.current as HTMLInputElement | undefined }), [ref]);
    useEffect(() => {
        setValue(props.value || undefined);
    }, [props.value]);
    useEffect(() => {
        if (!inputRef.current)
            return;
        $(inputRef.current).unmask();
        if (mask) {
            setValue($(inputRef.current).mask(...mask)[0].value);
            //(inputRef.current as any as HTMLInputElement)?.dispatchEvent(new FocusEvent('blur', {}));
            if (props.onChange)
                props.onChange({ target: inputRef.current });
        }
    }, [mask, inputRef.current]);
    return React.createElement("input", Object.assign({}, props, { ref: inputRef, value: value, onChange: e => setValue(e.target.value), onBlur: props.onChange }));
});
export function ServicePerson(props) {
    var _a, _b, _c, _d, _e;
    const cartOrder = useCartOrder();
    const [hasOpenedMenu, setHasOpenedMenu] = useState(false);
    const tourist = useMemo(() => props.tourist, [props.tourist]);
    const personId = useMemo(() => `${props.bookingService.id}_${props.personIdx}`, [props.bookingService.id, props.personIdx]);
    const placeName = useMemo(() => tourist.busPlaceName, [tourist.busPlaceName]);
    const placeNameBack = useMemo(() => tourist.busPlaceBackName, [tourist.busPlaceBackName]);
    const errors = useMemo(() => { var _a; return ((_a = cartOrder.errors.serviceErrors) === null || _a === void 0 ? void 0 : _a.filter(e => e.touristIdx === props.personIdx && e.serviceId === props.bookingService.id).map(e => e.field)) || []; }, [cartOrder.errors.serviceErrors]);
    const birthDateMessage = cartOrder.getTouristFieldMessage(props.bookingService.id, props.personIdx, 'birthDate');
    const documentRequiredConfig = useMemo(() => {
        switch (tourist.docType) {
            case foreignDocumentId.value:
                return cartOrder.configuration.optionalTouristFieldsConfig.foreignDocument;
            case foreignPassportId.value:
                return cartOrder.configuration.optionalTouristFieldsConfig.foreignPassport;
            case russianId.value:
                return cartOrder.configuration.optionalTouristFieldsConfig.russianPassport;
            case birthCert.value:
                return cartOrder.configuration.optionalTouristFieldsConfig.birthCertificate;
        }
        return undefined;
    }, [tourist.docType, cartOrder.configuration.optionalTouristFieldsConfig]);
    const docMask = useMemo(() => tourist.docType == foreignPassportId.value ? ['000000000', { selectOnFocus: false, }]
        : tourist.docType == russianId.value ? ['0000000000', { selectOnFocus: false, }]
            : tourist.docType == birthCert.value ? ['RrrCC000000', {
                    translation: {
                        'r': {
                            pattern: /[XVIxvi]/,
                            optional: true
                        },
                        'R': {
                            pattern: /[XVIxvi]/
                        },
                        'C': {
                            pattern: /[А-Яа-яЁё]/
                        },
                    },
                    selectOnFocus: false,
                }] : ['rrrrrrrrrrrrrrrrrrrr', {
                    translation: {
                        'r': {
                            pattern: /./,
                            optional: true
                        },
                    },
                    selectOnFocus: false,
                }], [tourist.docType]);
    const age = useMemo(() => props.age < 0 ? 18 : props.age, [props.age]);
    const realAge = useMemo(() => {
        var _a;
        if (!((_a = tourist.birthDate) === null || _a === void 0 ? void 0 : _a.isValid()))
            return age;
        let birthday = moment(tourist.birthDate);
        let baseDate = moment();
        if (!birthday.isValid() || !baseDate.isValid())
            return age;
        return Math.floor((Number.parseInt(baseDate.format('YYYYMMDD')) - Number.parseInt(birthday.format('YYYYMMDD'))) / 10000);
    }, []);
    const [useRussianDocuments, isRussian] = useMemo(() => {
        let russian = false;
        let use = (props.bookingService.isInternal && age >= 14) || !!props.bookingService.isRuInternal;
        if (tourist.citizenCountryId && cartOrder.configuration.citizenshipList) {
            const citizenship = cartOrder.configuration.citizenshipList.find(x => x.id == tourist.citizenCountryId);
            if (citizenship) {
                use = use && citizenship.id == cartOrder.configuration.dbRussiaId;
                russian = citizenship.id == cartOrder.configuration.dbRussiaId;
            }
        }
        return [use, russian];
    }, [tourist.citizenCountryId, cartOrder.configuration.citizenshipList, cartOrder.configuration.dbRussiaId, props.bookingService.isInternal, props.bookingService.isRuInternal, age]);
    const availableDocs = useMemo(() => {
        if (useRussianDocuments) {
            if (age < 14)
                return [birthCert, foreignPassportId];
            if (realAge < 14)
                return [russianId, foreignPassportId, birthCert];
            return [russianId, foreignPassportId];
        }
        return [isRussian ? foreignPassportId : foreignDocumentId];
    }, [useRussianDocuments, isRussian, age, realAge]);
    const visibleDocumentType = useMemo(() => {
        var _a;
        const selectedDocType = Number(tourist.docType);
        return availableDocs.some(doc => doc.value === selectedDocType)
            ? selectedDocType
            : (_a = availableDocs[0]) === null || _a === void 0 ? void 0 : _a.value;
    }, [availableDocs, tourist.docType]);
    useEffect(() => {
        if (visibleDocumentType === undefined || Number(tourist.docType) === visibleDocumentType)
            return;
        props.onChange(props.bookingService.id, props.personIdx, { docType: visibleDocumentType }, true);
    }, [visibleDocumentType, tourist.docType, props.bookingService.id, props.personIdx, props.onChange]);
    const onChange = (fieldName, newValue, skipSimilarUpdating) => {
        props.onChange(props.bookingService.id, props.personIdx, { [fieldName]: newValue }, skipSimilarUpdating);
        const birthDateValidationMessage = fieldName === 'birthDate' ? getBirthDateValidationMessage(newValue) : '';
        if (birthDateValidationMessage)
            cartOrder.setTouristFieldMessage(props.bookingService.id, props.personIdx, fieldName, birthDateValidationMessage);
        else
            cartOrder.removeTouristFieldMessage(props.bookingService.id, props.personIdx, fieldName);
        if (newValue)
            cartOrder.removeTouristError(props.bookingService.id, props.personIdx, fieldName);
    };
    const getNameValidationError = (value) => {
        if (!value)
            return '';
        const regex = tourist.docType == foreignPassportId.value ? foreignPassportNameRegex : commonNameRegex;
        if (regex.test(value))
            return '';
        return tourist.docType == foreignPassportId.value
            ? 'Только латинские символы'
            : 'Только латинские и русские символы';
    };
    const validateNameFieldElement = (element) => {
        const validationError = getNameValidationError(element.value);
        const field = element.closest('.form-group');
        if (!field)
            return;
        field.classList.toggle('error', !!validationError);
        const errorElement = field.querySelector('.error-msg');
        if (errorElement)
            errorElement.textContent = validationError;
    };
    const fixNameFieldValue = (element) => {
        var _a, _b;
        const newValue = (_b = (_a = element.value) === null || _a === void 0 ? void 0 : _a.replace(/[^a-zа-яё \-]/gi, '')) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        if (element.value != newValue)
            element.value = newValue;
        validateNameFieldElement(element);
    };
    const getBirthDateValidationMessage = (value) => {
        var _a;
        const birthDate = value ? moment(value) : null;
        if (!(birthDate === null || birthDate === void 0 ? void 0 : birthDate.isValid()))
            return '';
        const baseDate = moment(props.bookingService.end);
        if (!baseDate.isValid())
            return '';
        const actualAge = Math.floor((Number.parseInt(baseDate.format('YYYYMMDD')) - Number.parseInt(birthDate.format('YYYYMMDD'))) / 10000);
        if (props.isAdult && actualAge < ((_a = appSettings().childMaxAge) !== null && _a !== void 0 ? _a : 18))
            return 'Указан некорректный возраст или дата рождения взрослого.';
        if (!props.isAdult && actualAge !== props.age)
            return 'Указан некорректный возраст или дата рождения ребёнка.';
        return '';
    };
    const syncAutofilledFields = (form) => {
        const changes = {};
        const getInput = (name) => form.elements.namedItem(name);
        const syncText = (name, field, normalize) => {
            var _a;
            const input = getInput(name);
            if (!input)
                return;
            const value = normalize ? normalize(input.value) : input.value;
            if (input.value != value)
                input.value = value;
            if (((_a = tourist[field]) !== null && _a !== void 0 ? _a : '') != value)
                changes[field] = value;
        };
        const syncDate = (name, field) => {
            const input = getInput(name);
            const date = input ? parseAutofillDate(input.value) : undefined;
            if (!date)
                return;
            const value = moment(date);
            if (!tourist[field] || !moment(tourist[field]).isSame(value, 'day'))
                changes[field] = value;
        };
        const normalizeName = (value) => value.replace(/[^a-zа-яё \-]/gi, '').toUpperCase();
        syncText('surname', 'surname', normalizeName);
        syncText('name', 'name', normalizeName);
        syncText('middlename', 'middleName', normalizeName);
        syncText('docnumber', 'docNumber');
        syncDate('birthdate', 'birthDate');
        syncDate('docdate', 'docDate');
        syncDate('docexpirationdate', 'docExpirationDate');
        const fields = Object.keys(changes);
        if (!fields.length)
            return;
        props.onChange(props.bookingService.id, props.personIdx, changes);
        fields.forEach(field => {
            if (changes[field])
                cartOrder.removeTouristError(props.bookingService.id, props.personIdx, field);
        });
    };
    const autofillSync = useAutofillSync(syncAutofilledFields);
    const surnameMarkClick = (e) => {
        e.preventDefault();
        const parent = e.currentTarget.closest('.drop-mark');
        if (hasOpenedMenu && (parent === null || parent === void 0 ? void 0 : parent.querySelectorAll('.menu').length))
            return;
        e.stopPropagation();
        setHasOpenedMenu(true);
    };
    const configuredFieldLayouts = useMemo(() => {
        var _a;
        const configured = new Map();
        (((_a = cartOrder.configuration.touristFieldsLayout) === null || _a === void 0 ? void 0 : _a.fields) || []).forEach(field => {
            const name = normalizeTouristFieldName(field.name);
            if (name)
                configured.set(name, field);
        });
        return defaultTouristFieldOrder
            .map(name => {
            var _a;
            const defaults = defaultTouristFieldLayouts[name];
            const field = configured.get(name) || { name };
            const section = (field.section === 'person' || field.section === 'fields' ? field.section : defaults.section);
            return Object.assign(Object.assign(Object.assign({}, defaults), field), { name,
                section, order: (_a = field.order) !== null && _a !== void 0 ? _a : defaults.order, className: buildLayoutClassName(field, defaults.className) });
        })
            .filter(field => field.visible !== false)
            .sort((a, b) => a.order - b.order);
    }, [cartOrder.configuration.touristFieldsLayout]);
    const renderTouristField = (fieldName) => {
        var _a, _b, _c, _d, _e, _f;
        const surnameValidationError = getNameValidationError(tourist.surname);
        const nameValidationError = getNameValidationError(tourist.name);
        const middleNameValidationError = getNameValidationError(tourist.middleName);
        switch (fieldName) {
            case 'gender':
                return (React.createElement("div", { className: `gender p-t-30 ${errors.includes('gender') ? 'error' : ''}` },
                    React.createElement("span", { className: "arrived-age" }, props.isAdult ? _T.COMMON_ADULT : formatString(_T.COMMON_ADULT_AGE, [props.age])),
                    React.createElement("label", { htmlFor: `gender${personId}Male`, className: "radio-inline" },
                        React.createElement("input", { type: "radio", name: "gender", id: `gender${personId}Male`, value: "M", checked: tourist.gender == 'M', onChange: e => onChange('gender', e.target.checked ? 'M' : 'F') }),
                        React.createElement("span", { className: "box" }, _T.GENDER_MALE_SHORT)),
                    React.createElement("label", { htmlFor: `gender${personId}Female`, className: "radio-inline ml-2" },
                        React.createElement("input", { type: "radio", name: "gender", id: `gender${personId}Female`, value: "F", checked: tourist.gender == 'F', onChange: e => onChange('gender', e.target.checked ? 'F' : 'M') }),
                        React.createElement("span", { className: "box" }, _T.GENDER_FEMALE_SHORT)),
                    React.createElement("span", { className: "text-danger" }, "*")));
            case 'surname':
                return (React.createElement("div", { className: `form-group surname ${errors.includes('surname') || surnameValidationError ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-surname${personId}` },
                        _T.COMMON_SURNAME,
                        " ",
                        React.createElement("span", { className: "text-danger" }, "*")),
                    React.createElement("div", { className: "drop-mark" },
                        React.createElement(BlurAcceptInput, { type: "text", className: `form-control`, id: `arrived-surname${personId}`, maxLength: 25, name: "surname", value: (_a = tourist.surname) !== null && _a !== void 0 ? _a : '', onInput: e => fixNameFieldValue(e.currentTarget), onChange: e => onChange('surname', e.target.value) }),
                        React.createElement("a", { className: "mark", onClick: surnameMarkClick }),
                        hasOpenedMenu ? React.createElement(ClickAwayListener, { onClickAway: () => setHasOpenedMenu(false) },
                            React.createElement("div", { className: "menu" }, cartOrder.allTourists.map(t => React.createElement("a", { onClick: e => {
                                    props.onChange(props.bookingService.id, props.personIdx, {
                                        gender: t.gender,
                                        surname: t.surname,
                                        name: t.name,
                                        middleName: t.middleName,
                                        birthDate: t.birthDate,
                                        docNumber: t.docNumber,
                                        docDate: t.docDate,
                                        docExpirationDate: t.docExpirationDate,
                                        citizenCountryId: t.citizenCountryId,
                                        docType: t.docType,
                                    }, true);
                                    setHasOpenedMenu(false);
                                } }, t.fullDescr)))) : null),
                    React.createElement("div", { className: "error-msg text-danger extra-small" }, surnameValidationError)));
            case 'name':
                return (React.createElement("div", { className: `form-group name ${errors.includes('name') || nameValidationError ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-name${personId}` },
                        _T.COMMON_NAME,
                        " ",
                        React.createElement("span", { className: "text-danger" }, "*")),
                    React.createElement(BlurAcceptInput, { type: "text", className: `form-control`, id: `arrived-name${personId}`, maxLength: 15, name: "name", value: (_b = tourist.name) !== null && _b !== void 0 ? _b : '', onInput: e => fixNameFieldValue(e.currentTarget), onChange: e => onChange('name', e.target.value) }),
                    React.createElement("div", { className: "error-msg text-danger extra-small" }, nameValidationError)));
            case 'middleName':
                return (React.createElement("div", { className: `form-group middlename ${errors.includes('middleName') || middleNameValidationError ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-middle-name${personId}` },
                        _T.COMMON_MIDDLE_NAME,
                        !cartOrder.configuration.optionalTouristFieldsConfig.patronymic ? React.createElement("span", { className: "text-danger" }, "*") : null),
                    React.createElement(BlurAcceptInput, { type: "text", className: `form-control`, id: `arrived-middle-name${personId}`, maxLength: 15, name: "middlename", value: (_c = tourist.middleName) !== null && _c !== void 0 ? _c : '', onInput: e => fixNameFieldValue(e.currentTarget), onChange: e => onChange('middleName', e.target.value) }),
                    React.createElement("div", { className: "error-msg text-danger extra-small" }, middleNameValidationError)));
            case 'birthDate':
                return (React.createElement("div", { className: `form-group birthdate ${errors.includes('birthDate') || birthDateMessage ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-date${personId}` },
                        _T.COMMON_BIRTHDAY,
                        !cartOrder.configuration.optionalTouristFieldsConfig.birthDate ? React.createElement("span", { className: "text-danger" }, "*") : null),
                    React.createElement("div", { className: "select-group form-group no-padding input-daterange col-xs-12 date-group extra-box-date  ml-0 pl-1" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement(BootstrapDatetimePicker, { selected: tourist.birthDate ? moment(tourist.birthDate) : undefined, onChange: v => {
                                    onChange('birthDate', v ? moment(v) : null);
                                }, id: `arrived-date${personId}`, inputProps: {
                                    className: `birthdate text-left`,
                                    name: 'birthdate',
                                }, mask: ['0Z.0Z.00ZZ', {
                                        translation: {
                                            'Z': {
                                                pattern: /[0-9]/,
                                                optional: true
                                            },
                                        },
                                        selectOnFocus: true,
                                    }], maxDate: moment() }))),
                    React.createElement("div", { className: "error-msg text-danger extra-small" }, birthDateMessage)));
            case 'citizenship':
                return (React.createElement("div", { className: `form-group citizen-country-id ${errors.includes('citizenCountryId') ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-citizen-country-id${personId}` }, _T.COMMON_CITIZENSHIP),
                    React.createElement(BootstrapSelectPicker, { options: cartOrder.configuration.citizenshipList, selected: tourist.citizenCountryId, labelSelector: "name", valueSelector: "id", groupSelector: x => x.order == 1 ? 0 : 1, groupLabel: x => x.order == 1 ? _T.COMMON_OTHER_COUNTRIES : undefined, onChange: e => {
                            onChange('citizenCountryId', !e || typeof e == 'number' ? e || undefined : Number.parseInt(e));
                        }, selectProps: {
                            id: `arrived-citizen-country-id${personId}`,
                        } })));
            case 'docType':
                return (React.createElement("div", { className: `form-group doctype ${errors.includes('docType') ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-document-type${personId}` }, _T.COMMON_DOC_TYPE),
                    React.createElement(BootstrapSelectPicker, { options: availableDocs, selected: visibleDocumentType, labelSelector: "name", valueSelector: "value", onChange: e => {
                            onChange('docType', !e || typeof e == 'number' ? e || undefined : Number.parseInt(e));
                        }, selectProps: {
                            id: `arrived-document-type${personId}`,
                        }, hidden: availableDocs.length <= 1 }),
                    React.createElement("input", { type: "hidden", value: visibleDocumentType || '', readOnly: true, className: "form-control form-control-readonly-default-bg", id: `arrived-document-type${personId}` }),
                    React.createElement("input", { type: "text", readOnly: true, className: "form-control form-control-readonly-default-bg", value: (_e = (_d = availableDocs.find(dt => dt.value == visibleDocumentType)) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '', style: { display: availableDocs.length > 1 ? 'none' : undefined, caretColor: 'transparent' } })));
            case 'docNumber':
                return (React.createElement("div", { className: `form-group docnumber ${errors.includes('docNumber') ? 'error' : ''}` },
                    React.createElement("label", { htmlFor: `arrived-document${personId}` },
                        _T.COMMON_DOC_NUMBER,
                        !(documentRequiredConfig === null || documentRequiredConfig === void 0 ? void 0 : documentRequiredConfig.serial) ? React.createElement("span", { className: "text-danger required-sign" }, "*") : null),
                    React.createElement(BlurAcceptInput, { type: "text", className: `form-control`, id: `arrived-document${personId}`, maxLength: tourist.docType == foreignPassportId.value ? 9 : tourist.docType == russianId.value ? 10 : tourist.docType == birthCert.value ? 12 : 20, mask: docMask, name: "docnumber", value: (_f = tourist.docNumber) !== null && _f !== void 0 ? _f : '', onChange: e => {
                            onChange('docNumber', e.target.value);
                        } })));
            case 'docExpirationDate':
                if (visibleDocumentType != foreignPassportId.value && visibleDocumentType != foreignDocumentId.value)
                    return null;
                return (React.createElement("div", { className: `form-group docexpirationdate ${errors.includes('docExpirationDate') ? 'error' : undefined}`, id: `arrived-document-date${personId}-container` },
                    React.createElement("label", { htmlFor: `arrived-document-date${personId}` },
                        _T.COMMON_EXP_DATE,
                        !(documentRequiredConfig === null || documentRequiredConfig === void 0 ? void 0 : documentRequiredConfig.date) ? React.createElement("span", { className: "text-danger required-sign" }, "*") : null),
                    React.createElement("div", { className: "select-group form-group no-padding input-daterange col-xs-12 date-group extra-box-date  ml-0 pl-1" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement(BootstrapDatetimePicker, { selected: tourist.docExpirationDate ? moment(tourist.docExpirationDate) : undefined, onChange: v => {
                                    onChange('docExpirationDate', v ? moment(v) : undefined);
                                }, id: `arrived-document-date${personId}`, inputProps: {
                                    className: `docexpirationdate text-left`,
                                    name: 'docexpirationdate',
                                }, mask: ['0Z.0Z.00ZZ', {
                                        translation: {
                                            'Z': {
                                                pattern: /[0-9]/,
                                                optional: true
                                            },
                                        },
                                        selectOnFocus: true,
                                    }], minDate: moment() })))));
            case 'docDate':
                if (visibleDocumentType == foreignPassportId.value || visibleDocumentType == foreignDocumentId.value)
                    return null;
                return (React.createElement("div", { className: `form-group docdate ${errors.includes('docDate') ? 'error' : ''}`, id: `arrived-document-date-issue${personId}-container` },
                    React.createElement("label", { htmlFor: `arrived-document-date-issue${personId}` },
                        _T.COMMON_ISSUE_DATE,
                        !(documentRequiredConfig === null || documentRequiredConfig === void 0 ? void 0 : documentRequiredConfig.date) ? React.createElement("span", { className: "text-danger required-sign" }, "*") : null),
                    React.createElement("div", { className: "select-group form-group no-padding input-daterange col-xs-12 date-group extra-box-date  ml-0 pl-1" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement(BootstrapDatetimePicker, { selected: tourist.docDate ? moment(tourist.docDate) : undefined, onChange: v => {
                                    onChange('docDate', v ? moment(v) : undefined);
                                }, id: `arrived-document-date-issue${personId}`, inputProps: {
                                    className: `docdate text-left`,
                                    name: 'docdate',
                                }, mask: ['0Z.0Z.00ZZ', {
                                        translation: {
                                            'Z': {
                                                pattern: /[0-9]/,
                                                optional: true
                                            },
                                        },
                                        selectOnFocus: true,
                                    }], maxDate: moment() })))));
        }
    };
    const renderLayoutFields = (section) => configuredFieldLayouts
        .filter(field => field.section === section)
        .map(field => {
        const content = renderTouristField(field.name);
        return content ? (React.createElement("div", { className: field.className, key: field.name }, content)) : null;
    })
        .filter(Boolean);
    const personFields = renderLayoutFields('person');
    const fields = renderLayoutFields('fields');
    const personContainerClassName = (_b = (_a = cartOrder.configuration.touristFieldsLayout) === null || _a === void 0 ? void 0 : _a.personContainerClassName) !== null && _b !== void 0 ? _b : 'col-md-2 col-xs-12 row no-gutters';
    const fieldsContainerClassName = (_d = (_c = cartOrder.configuration.touristFieldsLayout) === null || _c === void 0 ? void 0 : _c.fieldsContainerClassName) !== null && _d !== void 0 ? _d : (personFields.length ? 'col-md-10 col-xs-12 row' : 'col-xs-12 row');
    return (React.createElement("div", { className: `row tourist tourist-${personId} ${errors.length > 0 ? 'error' : ''}`, "data-age": props.age, "data-service-is-internal": props.bookingService.isInternal ? '1' : '0', "data-service-is-ru-internal": props.bookingService.isRuInternal ? '1' : '0', "data-place-id": tourist.busPlaceId },
        React.createElement("form", Object.assign({ ref: autofillSync.rootRef }, autofillSync.autofillProps, { className: "tourist-form react-cart-autofill-scope", "data-index": props.personIdx, "data-gender": (_e = tourist.gender) !== null && _e !== void 0 ? _e : '', autoComplete: "off" }),
            personFields.length ? React.createElement("div", { className: personContainerClassName }, personFields) : null,
            fields.length ? React.createElement("div", { className: fieldsContainerClassName }, fields) : null)));
}
